import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap'
import './assets/styles/main.css'

import axios from 'axios'
import config from '@/config.json'
import { initAuth } from '@/auth/initAuth'
import { setupLogoutSync } from '@/auth/syncLogout'

axios.defaults.baseURL = config.apiBaseUrl

async function bootstrap() {
  await initAuth()       // 先試著恢復登入狀態
  setupLogoutSync()      // 設定跨分頁同步登出

  const app = createApp(App)
  app.use(router)
  app.use(i18n)
  app.mount('#app')
}

bootstrap()
